import { Receipt, Client, AdminUser, CompanyInfo, VehicleInfo, DashboardStats } from '../types';

// 회사 정보
export const COMPANY_INFO: CompanyInfo = {
  id: 'mock-company-id',
  name: 'Demo Logistics Inc.',
  business_number: '123-45-67890',
  contact_person: '홍길동',
  contact_phone: '010-1234-5678',
  address: '서울시 강남구 테헤란로 123',
};

// 데모 관리자 계정
export const DEMO_ACCOUNTS = {
  admin: { email: 'admin@example.com', password: 'demo1234' },
  user: { email: 'user@example.com', password: 'demo1234' },
};

// 현재 로그인한 관리자 (데모용)
export const CURRENT_ADMIN: AdminUser = {
  id: '1',
  user_id: 'admin-user-1',
  company_id: 'mock-company-id',
  role: 'super_admin',
  full_name: '관리자',
  phone: '010-1234-5678',
  email: 'admin@example.com',
  is_active: true,
  created_at: '2025-01-01T00:00:00Z',
  companies: {
    name: 'Demo Logistics Inc.',
  },
};

// 관리자 목록
export const MOCK_USERS: AdminUser[] = [
  CURRENT_ADMIN,
  {
    id: '2',
    user_id: 'admin-user-2',
    company_id: 'mock-company-id',
    role: 'company_admin',
    full_name: '김철수',
    phone: '010-2345-6789',
    email: 'kim@example.com',
    is_active: true,
    created_at: '2025-01-15T00:00:00Z',
    companies: {
      name: 'Demo Logistics Inc.',
    },
  },
  {
    id: '3',
    user_id: 'admin-user-3',
    company_id: 'mock-company-id',
    role: 'company_admin',
    full_name: '이영희',
    phone: '010-3456-7890',
    email: 'lee@example.com',
    is_active: false,
    created_at: '2025-02-01T00:00:00Z',
    companies: {
      name: 'Demo Logistics Inc.',
    },
  },
];

// 업체(Client) 목록
export const MOCK_CLIENTS: Client[] = [
  {
    id: 'client-001',
    company_name: 'Demo Logistics Inc.',
    location: '본사',
    contact_person: '홍길동',
    contact_phone: '010-1234-5678',
    status: 'active',
    installed_at: '2025-01-01T09:00:00Z',
    last_seen_at: new Date().toISOString(),
    created_at: '2025-01-01T00:00:00Z',
  },
  {
    id: 'client-002',
    company_name: 'Demo Logistics Inc.',
    location: '인천지점',
    contact_person: '박지훈',
    contact_phone: '010-5678-1234',
    status: 'active',
    installed_at: '2025-01-15T10:00:00Z',
    last_seen_at: new Date(Date.now() - 1000 * 60 * 30).toISOString(), // 30분 전
    created_at: '2025-01-15T00:00:00Z',
  },
  {
    id: 'client-003',
    company_name: 'Demo Logistics Inc.',
    location: '부산지점',
    contact_person: '최수민',
    contact_phone: '010-9012-3456',
    status: 'inactive',
    installed_at: null,
    last_seen_at: null,
    created_at: '2025-02-01T00:00:00Z',
  },
];

// 차량 정보 (자동완성용)
export const MOCK_VEHICLES: VehicleInfo[] = [
  { vehicle_number: '서울 12가 3456', driver_name: '김기사', driver_phone: '010-1111-2222' },
  { vehicle_number: '경기 34나 5678', driver_name: '박기사', driver_phone: '010-3333-4444' },
  { vehicle_number: '인천 56다 7890', driver_name: '이기사', driver_phone: '010-5555-6666' },
  { vehicle_number: '부산 78라 1234', driver_name: '최기사', driver_phone: '010-7777-8888' },
  { vehicle_number: '대구 90마 5678', driver_name: '정기사', driver_phone: '010-9999-0000' },
  { vehicle_number: '제주 12바 9012', driver_name: '강기사', driver_phone: '010-1234-5678' },
];

// 전표 목록 생성 함수
const generateReceipts = (): Receipt[] => {
  const today = new Date();
  const receipts: Receipt[] = [];
  const shippers = ['홍길동', '김철수', '이영희', '박지훈', '최수민'];
  const units = ['1대분', '2대분', '3대분', '4대분'];
  const paymentMethods = ['입금', '카드'];

  for (let i = 0; i < 50; i++) {
    const date = new Date(today);
    date.setDate(date.getDate() - Math.floor(i / 5)); // 5개씩 같은 날짜
    date.setHours(9 + (i % 8), Math.floor(Math.random() * 60), 0, 0);

    const quantity = Math.floor(Math.random() * 100) + 10;
    const unitPrice = 5000;

    receipts.push({
      id: `receipt-${i + 1}`,
      receipt_number: `2025${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}${String(i + 1).padStart(5, '0')}`,
      shipper_name: shippers[i % shippers.length],
      pallet_quantity: quantity,
      unit: units[i % units.length],
      vehicle_count: (i % 4) + 1,
      vehicle_number: MOCK_VEHICLES[i % MOCK_VEHICLES.length].vehicle_number,
      driver_name: MOCK_VEHICLES[i % MOCK_VEHICLES.length].driver_name,
      driver_phone: MOCK_VEHICLES[i % MOCK_VEHICLES.length].driver_phone,
      payment_method: paymentMethods[i % paymentMethods.length],
      unit_price: unitPrice,
      total_amount: quantity * unitPrice,
      created_at: date.toISOString(),
      client: MOCK_CLIENTS[i % MOCK_CLIENTS.length],
    });
  }

  return receipts;
};

export const MOCK_RECEIPTS: Receipt[] = generateReceipts();

// 대시보드 통계 계산
export const getDashboardStats = (): DashboardStats => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);

  const todayReceipts = MOCK_RECEIPTS.filter(r => {
    const date = new Date(r.created_at);
    date.setHours(0, 0, 0, 0);
    return date.getTime() === today.getTime();
  });

  const monthReceipts = MOCK_RECEIPTS.filter(r => {
    const date = new Date(r.created_at);
    return date >= monthStart;
  });

  return {
    todayCount: todayReceipts.length,
    monthCount: monthReceipts.length,
    todayAmount: todayReceipts.reduce((sum, r) => sum + r.total_amount, 0),
    monthAmount: monthReceipts.reduce((sum, r) => sum + r.total_amount, 0),
    recentReceipts: MOCK_RECEIPTS.slice(0, 5),
  };
};

// 차량번호 자동완성
export const getVehicleSuggestions = (query: string): string[] => {
  if (query.length < 2) return [];

  return MOCK_VEHICLES
    .filter(v => v.vehicle_number.includes(query))
    .map(v => v.vehicle_number);
};

// 차량 정보 조회
export const getVehicleInfo = (vehicleNumber: string): VehicleInfo | null => {
  return MOCK_VEHICLES.find(v => v.vehicle_number === vehicleNumber) || null;
};
